import { Resources } from 'constants/resources';

import React from 'react';

import { usePermissions } from 'hooks/usePermissions';
import { ProviderAccountsManagerField } from 'pages/Finance/ProviderAccounts/components/ProviderAccountsManagerField';
import { StyledSpanField } from 'pages/Finance/ProviderAccounts/ProviderAccountsList/ProviderAccountsList.styled';
import { StyledTextField } from 'pages/Finance/ProviderAccounts/ProviderAccountsShow/ProviderAccountsShow.styled';
import { RecordContextProvider } from 'react-admin';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Chip } from 'shared/mui/Chips';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { BooleanField, EmbeddedFunctionField } from 'shared/react-admin/Fields';
import { EmbeddedArrayField } from 'shared/react-admin/Fields/Embedded/EmbeddedArrayField/EmbeddedArrayField';
import { Company } from 'types/embedded/company';
import { Provider } from 'types/embedded/provider';
import { User } from 'types/embedded/user';
import { WorkTeam } from 'types/embedded/workTeam';

import { ProviderAccountsMerchantsField } from '../../components/ProviderAccountsMerchantsField';

type ProviderAccountsShowTableProps = {
  handleOpenCompanyModal: (record: Partial<Company> | undefined) => void;
  handleOpenRecordModalProvider: (record: Provider | undefined) => void;
};

export const ProviderAccountsShowTable = ({
  handleOpenCompanyModal,
  handleOpenRecordModalProvider,
}: ProviderAccountsShowTableProps) => {
  const { hasResourceAccess } = usePermissions();

  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '179px' } } }}>
      <TableRowWrapper label="Партнерский">
        <BooleanField source="partner" />
      </TableRowWrapper>
      <TableRowWrapper label="Компания">
        <EmbeddedFunctionField
          label="Компания"
          render={(value: Partial<Company>) => {
            return (
              <RecordContextProvider value={value}>
                <StyledTextField onClick={() => handleOpenCompanyModal(value)} source="name" />
              </RecordContextProvider>
            );
          }}
          sourceField="company"
        />
      </TableRowWrapper>
      {hasResourceAccess(Resources.Providers) && (
        <TableRowWrapper label="Провайдер">
          <EmbeddedFunctionField
            cellClassName="column-provider"
            render={(value: Provider) => {
              return (
                <StyledSpanField onClick={() => handleOpenRecordModalProvider(value)}>
                  {value.name}
                </StyledSpanField>
              );
            }}
            sortBy="provider.name"
            sourceField="provider"
          />
        </TableRowWrapper>
      )}
      <TableRowWrapper label="Мерчанты">
        <ProviderAccountsMerchantsField cellClassName="column-merchants" sourceField="merchants" />
      </TableRowWrapper>
      <TableRowWrapper label="Рабочая группа">
        <EmbeddedFunctionField render={(value: WorkTeam) => value.name} sourceField="workTeam" />
      </TableRowWrapper>
      <TableRowWrapper label="Руководитель группы">
        <EmbeddedFunctionField
          cellClassName="column-workTeam"
          label="Руководитель группы"
          render={(value: WorkTeam) => {
            return (
              <RecordContextProvider value={value}>
                <ProviderAccountsManagerField />
              </RecordContextProvider>
            );
          }}
          sourceField="workTeam"
        />
      </TableRowWrapper>
      <TableRowWrapper label="Ответственные">
        <EmbeddedArrayField
          render={(values) => {
            return values.map((v) => {
              return (
                <Chip
                  key={v['@id']}
                  label={`${(v as User).firstName} ${(v as User).lastName}`}
                  sx={{ marginRight: '4px', marginBottom: '4px' }}
                />
              );
            });
          }}
          sourceField="members"
        />
      </TableRowWrapper>
    </CardTable>
  );
};
